var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddVidjet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0348 16.0401C20.4376 17.4525 19.5034 18.6971 18.314 19.6651C17.1247 20.6331 15.7163 21.295 14.212 21.5929C12.7077 21.8908 11.1534 21.8157 9.6848 21.3742C8.21625 20.9326 6.87823 20.138 5.78771 19.0599C4.69719 17.9818 3.88737 16.6529 3.42907 15.1895C2.97076 13.7261 2.87792 12.1727 3.15866 10.6651C3.4394 9.1575 4.08516 7.74164 5.0395 6.54129C5.99385 5.34093 7.2277 4.39263 8.6332 3.7793",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7767 12.388C21.7767 11.1552 21.5339 9.9344 21.0621 8.79539C20.5903 7.65638 19.8988 6.62145 19.027 5.74969C18.1553 4.87793 17.1203 4.18642 15.9813 3.71462C14.8423 3.24283 13.6215 3 12.3887 3V12.388H21.7767Z",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddVidjet);
export default __webpack_public_path__ + "static/media/addVidjet.cdab2e25b27c5f87ad67548441c11f26.svg";
export { ForwardRef as ReactComponent };